
























































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DataResume from "@/services/DataResume";
import Autocomplete from "@/components/Autocomplete.vue";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";
import ModalSpri from "@/components/modal/CardModalSpri.vue";
import ModalRujukan from "@/components/modal/CardModalRujukan.vue";
import { isEmpty } from "lodash";
import { storeDokter } from "@/store/modules/dokter";
import { storeResume } from "@/store/modules/resume";
import { storeDiagnosa } from "@/store/modules/diagnosa";
import { storeProcedure } from "@/store/modules/procedure";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeSpri } from "@/store/modules/spri";
import { storeSoap } from "@/store/modules/soap";
import { storeFaskes } from "@/store/modules/faskes";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeCopy } from "@/store/modules/copy";
import http from "@/axios/http-common";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import storeBilling from "@/store/modules/Billing";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: {
    Autocomplete,
    ModalKonfirmasi,
    ModalSpri,
    ModalRujukan
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardDPP extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  // @Prop() sess_login!: object;
  // @Prop() dtResume!: Array<object>;
  @Prop() dataSoap!: object;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  sess_login = this.stateuser;
  dokter = {};
  valid = true;
  diagnosa = [];
  tindakan = [];
  dpjp: object = {};
  loading = false;
  activeDiag = false;
  activeProc = false;
  // items= []
  searchStringDiag = "";
  searchStringDiag2 = "";
  searchResultDiag = null;
  editedItemDiag = [];
  searchStringProc = "";
  searchStringProc2 = "";
  searchResultProc = null;
  editedItemProc = [];
  hideNoResults = true;
  nama = "";
  kode = "";
  editedIndexDiag = null;
  editedIndexProc = null;
  arrayDiag = [];
  arrayProc = [];
  idDischarge = "";
  dtDischarge: object = {};
  rujukan = "";
  catatan = "";
  signed = 1;
  alert = "";
  pageTab = "";
  modalOpenKonfirmasi = false;
  modalOpenRujukan = false;
  modalOpenSpri = false;
  msgConfirm = "";
  soap: object = {};
  dataRujukan: object = {};
  tujuan: object = {};
  emptyDischarge = { id: 0, nama: "", label: "", value: "" };
  disableDpp = true;
  overlay = false;
  paramresume = {
    reg: this.register,
    idUser: this.sess_login.id
  };
  _timerId;
  dataResume = null;
  tlPrb = null;
  tlPrbNote = null;
  validasiIter = [v => !!v || "Kolom ini harus diisi bila Iter!"];

  get hasilDiagnosis() {
    return storeBilling.diagnosis;
  }
  get hasilProcedure() {
    return storeBilling.procedure;
  }

  get validasiTLPrb() {
    if (
      this.isShowTlPrb &&
      this.isRujukanEndSoon &&
      !this.loading &&
      !this.tlPrb
    ) {
      return ["Harus diisi bila masa berlaku rujukan <30 hari!"];
    }

    return true;
  }

  get isRujukanEndSoon() {
    return RegisterKunjungan.isRujukanEndSoon;
  }

  get statusPaste() {
    return storeCopy.copyDiagnosa;
  }
  get statusPasteInstant() {
    return storeCopy.copyDiagnosaInstant;
  }
  get paste() {
    return storeCopy.pastediagnosa;
  }
  get listDokter() {
    return storeDokter.listAll;
  }
  get listDischarge() {
    return MasterReferensi.caraKeluar;
  }
  get staterujukan() {
    return storeRujukan.detailrujukan;
  }
  get statespri() {
    return storeSpri.spri;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get statefaskes() {
    return storeFaskes.faskes;
  }

  get stateuser() {
    return userModule.user;
  }

  get stateresume() {
    return storeResume.resume;
  }

  get statediagnosa() {
    return storeDiagnosa.diagnosa;
  }

  get stateprocedure() {
    return storeProcedure.procedure;
  }

  get isDisableDpjp() {
    console.log("is disable dpjp", this.dataResume);
    return (
      this.dataResume &&
      this.dataResume.length > 0 &&
      this.dataResume[0]?.dpjp?.id != this.sess_login.id
    );
  }

  // get soapInput() {
  //   return storeSoap.ctt;
  // }

  get soapInput() {
    const soap = this.soapList.filter(
      soap => soap.user_id == this.stateuser.id
    );

    return soap.length > 0 ? soap[0] : null;
  }

  get soapList() {
    return SoapRanapStore.soapList.filter(soap => soap.unit_id < "30");
  }

  get listTLPrb() {
    return [
      { id: "1", nama: "Stabil" },
      { id: "2", nama: "Belum Stabil" },
      { id: "3", nama: "Iterasi" }
    ];
  }

  get listIter() {
    return ["1X", "2X"];
  }

  get isShowTlPrb() {
    return (
      ["06", "10", "12", "13", "17", "27"].includes(
        this.stateuser.unit_group_id
      ) && this.infoBpjs
    );
  }

  get isShowIterField() {
    return this.tlPrb == "3";
  }

  get infoBpjs() {
    return RegisterKunjungan.infoBpjs;
  }

  mounted() {
    this.getResume();

    if (this.stateuser.unit_id == "01") {
      if (isEmpty(this.dokter)) {
        this.dokter = AsesmenGadarMedisStore.asesmen?.content.dokter.id;
      }

      if (isEmpty(this.dtDischarge)) {
        const disc = this.listDischarge.find(
          item =>
            item.id ==
            AsesmenGadarMedisStore.asesmen?.content.tindakLanjut.caraPulang
        );

        this.dtDischarge = disc;
      }

      const tujuanRujukan =
          AsesmenGadarMedisStore.asesmen?.content.tindakLanjut?.tujuanRujukan,
        faskesRujukan = storeFaskes.faskes.find(
          item => item.id == tujuanRujukan
        );

      if (tujuanRujukan) {
        this.rujukan = faskesRujukan?.nama;
      }
    } else {
      storeSpri.act_spri_on_reg(this.register);
      storeRujukan.act_rujukan_on_reg(this.register);
    }
  }

  @Watch("statusPasteInstant")
  changeStatusPasteInstant(val) {
    if (val) {
      this.tempelDiagnosis(this.paste);
    }
  }

  modalSpri(v) {
    if (this.dtDischarge["id"] == 5) {
      // this.modalOpenSpri = !this.modalOpenSpri;
      this.pageTab = "tab-suket";
      if (this.statespri.length < 1) {
        this.$emit("pageTabSpri", {
          tab: this.pageTab,
          modal: true
        });
        // } else {
        //    // console.log("spri isi");
        //   this.$emit("pageTabSpri", {
        //     tab: this.pageTab,
        //     modal: false
        //   });
      }

      // this.$emit("pageTabSpri", {
      //   tab: this.pageTab,
      //   modal: true
      // });
    } else if (this.dtDischarge["id"] == 2) {
      this.pageTab = "tab-konsul";

      // if (this.staterujukan) {
      //   console.log("rujukan ksg");

      //   this.$emit("pageTabRujukan", {
      //     tab: this.pageTab,
      //     modal: true
      //   });
      // } else {
      //   console.log("rujukan isi");

      //   this.$emit("pageTabRujukan", {
      //     tab: this.pageTab,
      //     modal: false
      //   });
      // }

      // this.$emit("pageTabRujukan", {
      //   tab: this.pageTab,
      //   modal: true
      // });
    }
  }

  @Watch("sess_login")
  sessChange(val) {
    this.sess_login = val;

    // this.getResume()
  }

  @Watch("register")
  change(val) {
    this.register = val;
    // this.getResume()
  }
  // @Watch("dtResume")
  // changeResume(val) {
  //   this.clearform();

  //   this.dtResume = val;
  //   this.getResume();
  // }
  @Watch("dataSoap")
  changeSoap() {
    if (!isEmpty(this.soap)) {
      this.soap = {
        s: this.dataSoap["data"][0]["s"],
        o: this.dataSoap["data"][0]["o"],
        a: this.dataSoap["data"][0]["a"],
        p: this.dataSoap["data"][0]["p"]
      };
    }
  }
  searchDiag(termSearch) {
    http
      .getDataParam("/referensi/diagnosis-icd/search", {
        params: { term: termSearch }
      })
      .then(res => {
        // console.log(res.data);
        this.diagnosa = res.data;
      })
      .finally();
  }

  @Watch("searchStringDiag")
  searched() {
    this.diagnosa = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringDiag === null || this.searchStringDiag.length < 2)
        return;

      this.searchDiag(this.searchStringDiag);
    }, 500);
  }
  @Watch("searchStringDiag2")
  searchedEdit(val) {
    this.diagnosa = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringDiag2 === null || this.searchStringDiag2.length < 2)
        return;
      this.searchDiag(this.searchStringDiag2);
    }, 500);
  }

  itemChangeDiag(e) {
    this.editedItemDiag.push({
      nama: e.dx,
      kode: e.kddx,
      kasus: null,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.stateuser.id
    });
    this.arrayDiag.push({ kode: e.kddx, kasus: null });
    this.$nextTick(() => {
      this.searchStringDiag = "";
      this.searchResultDiag = null;
      this.diagnosa = [];
    });
  }
  toggleEditDiag(i, diag) {
    if (
      this.stateuser.id == this.dataResume[0]?.dpjp?.id ||
      this.stateuser.id == diag.dr_id
    ) {
      if (this.editedIndexDiag !== i) {
        this.editedIndexDiag = i;
      } else {
        this.editedIndexDiag = null;
      }
    } else {
      alert("tidak bisa mengubah diagnosa yang dicatat DPJP!");
      console.log(this.stateuser.id, diag);

      this.editedIndexDiag = null;
    }
  }
  editItemChangeDiag(e) {
    Object.assign(this.editedItemDiag[this.editedIndexDiag], {
      nama: e.dx,
      kode: e.kddx,
      kasus: null,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.dokter["id"]
    });
    this.$set(this.arrayDiag, this.editedIndexDiag, {
      kode: e.kddx,
      kasus: this.editedItemDiag[this.editedIndexDiag].kasus
    });

    this.$nextTick(() => {
      this.searchStringDiag = "";
      this.searchResultDiag = null;
    });
  }
  delDiag(index) {
    this.editedItemDiag.splice(index, 1);
    this.arrayDiag.splice(index, 1);
    this.editedIndexDiag = null;
  }
  searchProc(termSearch) {
    http
      .getDataParam("/referensi/prosedur-icd/search", {
        params: { term: termSearch }
      })
      .then(res => {
        // console.log(res.data);
        this.tindakan = res.data;
      })
      .finally();
  }
  @Watch("searchStringProc")
  searchedProc() {
    this.tindakan = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringProc === null || this.searchStringProc.length < 2)
        return;
      this.searchProc(this.searchStringProc);
    }, 500);
  }
  @Watch("searchStringProc2")
  searchedEditProc() {
    this.tindakan = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringProc2 === null || this.searchStringProc2.length < 2)
        return;
      this.searchProc(this.searchStringProc2);
    }, 500);

    // storeProcedure.act_procedure_all(this.searchStringProc2);
    // this.tindakan = this.stateprocedure;
  }
  itemChangeProc(e) {
    this.editedItemProc.push({
      nama: e.tindakan,
      kode: e.kode,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.stateuser.id
    });
    this.arrayProc.push(e.kode);
    this.$nextTick(() => {
      this.searchStringProc = "";
      this.searchResultProc = null;
    });
  }
  editProc(i, proc) {
    // this.editedIndexProc = i;

    if (
      this.stateuser.id == this.dataResume[0]?.dpjp?.id ||
      this.stateuser.id == proc.dr_id
    ) {
      if (this.editedIndexProc !== i) {
        this.editedIndexProc = i;
      } else {
        this.editedIndexProc = null;
        this.activeProc = null;
      }
    } else {
      alert("tidak bisa mengubah diagnosa yang dicatat DPJP!");

      this.editedIndexProc = null;
      this.activeProc = null;
    }
  }
  editItemChangeProc(e) {
    Object.assign(this.editedItemProc[this.editedIndexProc], {
      nama: e.tindakan,
      kode: e.kode,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.dokter["id"]
    });
    this.$set(this.arrayProc, this.editedIndexProc, e.kode);

    this.$nextTick(() => {
      this.searchStringProc = "";
      this.searchResultProc = null;
    });
  }
  delProc(index) {
    this.editedItemProc.splice(index, 1);
    this.arrayProc.splice(index, 1);
    this.activeProc = null;
  }

  changeDischarge(e) {
    this.dtDischarge = e;
  }

  getResume() {
    // const data = this.dtResume;
    // storeResume.act_resume_on_reg(this.register);
    // this.clearform();
    this.loading = true;
    const dpjp_id = "";
    const dt = DataResume.getDataResume(this.register, dpjp_id);
    dt.then(dt => {
      // appModule.setLoading(false);

      const data = dt["data"];
      this.dataResume = dt["data"];

      if (data.length < 1 || data.length == undefined) {
        this.dokter = this.sess_login;

        if (this.stateuser.profesi == "Dokter") {
          this.disableDpp = false;
        } else {
          this.disableDpp = true;
        }

        if (isEmpty(this.dtDischarge) && !this.disableDpp) {
          this.dtDischarge = this.listDischarge.find(it => (it.id = 1));
        }
      } else {
        // this.dpjp = data[0]["dpjp"];
        this.dtDischarge = data[0]["discharge"];
        this.catatan = data[0]["catatan"];

        // if (data[0]["dpjp"]["id"] == this.sess_login["id"]) {
        //   this.disableDpp = false;
        //   this.dokter = this.sess_login;
        //   console.log("dokter login", data[0]["dpjp"]["id"]);
        // } else {
        //   console.log("dokter", this.dokter);
        //   this.dokter = data[0].dpjp;
        //   this.disableDpp = false;
        // }

        if (this.stateuser.profesi == "Dokter") {
          this.disableDpp = false;
          this.dokter = data[0].dpjp;
          // console.log("dokter login", data[0]["dpjp"]["id"]);
        } else {
          // console.log("dokter", this.dokter);
          this.dokter = data[0].dpjp;
          this.disableDpp = true;
        }

        data[0].diagnosis.map(v => {
          this.editedItemDiag.push(v);
        });

        data[0]["prosedur"].map(v => {
          this.editedItemProc.push(v);
        });

        this.tlPrb = data[0]["tl_prb_id"];
        this.tlPrbNote = data[0]["tl_prb_note"];

        // console.log(data[0].diagnosis);
        this.arrayDiag = this.editedItemDiag.map(item => {
          return { kode: item.kode, kasus: item.kasus, text: item.text };
        });
        // this.editedItemDiag = this.editedItemDiag.map(item => {
        //   return {
        //     kode: item.kode,
        //     kasus: item.kasus,
        //     nama: item.nama,
        //     urut: item.urut,
        //     text: item.text,
        //     tgl: item.tgl,
        //     unit_id: item.unit_id,
        //     dr_id: item.dr_id
        //   };
        // });
        this.arrayProc = this.editedItemProc.map(item => item.kode);
        this.editedItemProc = this.editedItemProc.map(item => {
          return {
            kode: item.kode,
            nama: item.nama,
            urut: item.urut,
            tgl: item.tgl,
            text: item.text,
            unit_id: item.unit_id,
            dr_id: item.dr_id
          };
        });
      }
    }).finally(() => {
      this.loading = false;
    });

    //     }
    // })
  }
  clearform() {
    this.dtDischarge = {};
    this.editedItemDiag = [];
    this.editedItemProc = [];
    this.arrayDiag = [];
    this.arrayProc = [];
    this.dokter = this.sess_login;
    this.dataResume = null;
    this.tlPrb = null;
    this.tlPrbNote = null;
  }
  async simpanResume() {
    const id_dpjp = this.dokter["id"];
    // const id_dpjp = this.sess_login["id"];
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      // if (isEmpty(this.arrayDiag)) {
      if (isEmpty(this.editedItemDiag)) {
        this.alert = "Diagnosa tidak boleh kosong";
        appModule.sendErrorAlert(this.alert);
      } else {
        appModule.setLoading(true);
        // this.overlay = !this.overlay;
        if (this.stateresume.length == 0) {
          // ini fitur eksperimental untuk otomatis simpan soap + diag cuma untuk dr.bagus
          if (
            [1, 268].includes(this.stateuser.id) &&
            !this.soapInput
            // !this.soapInput.id &&
            // this.soapInput.s &&
            // this.soapInput.o &&
            // this.soapInput.a &&
            // this.soapInput.p
          ) {
            storeCopy.act_soap_instant_save();

            // delay the diag save...
            await new Promise(resolve => setTimeout(resolve, 2000));
          }

          const dt = await DataResume.saveDataResume(
            this.register,
            this.rm,
            id_dpjp,
            this.dtDischarge["id"],
            this.rujukan,
            this.catatan,
            this.sess_login["id"],
            this.editedItemDiag,
            this.editedItemProc,
            this.tlPrb,
            this.tlPrbNote
            // this.arrayProc
          )
            .then(dt => {
              appModule.setLoading(false);

              // this.overlay = !this.overlay;
              if (dt["status"] != 1) {
                appModule.sendErrorAlert(dt["message"]);
              } else {
                appModule.NoticeDelay("Berhasil Simpan Resume");
                // this.$emit("updtResume", "");
                this.clearform();
                this.getResume();

                storeResume.act_resume_on_reg(this.paramresume);
                this.$emit("tersimpan", {
                  discharge_id: dt["data"].discharge_id
                });

                if (this.stateuser.unit_id != "01") {
                  if (dt["data"].discharge_id == 5) {
                    if (isEmpty(this.statespri)) {
                      this.modalOpenKonfirmasi = true;
                      this.msgConfirm = "Surat Keterangan Rawat Inap";
                    }
                  } else if (dt["data"].discharge_id == 2) {
                    if (isEmpty(this.staterujukan)) {
                      this.modalOpenKonfirmasi = true;
                      this.msgConfirm = "Surat Rujukan Rawat Jalan";
                    }
                  }
                }
              }
            })
            .finally(() => {
              appModule.setLoading(false);
            });
        } else {
          const dt = await DataResume.editDataResume(
            this.register,
            this.rm,
            id_dpjp,
            this.dtDischarge["id"],
            this.rujukan,
            this.catatan,
            this.sess_login["id"],
            this.editedItemDiag,
            this.editedItemProc,
            this.tlPrb,
            this.tlPrbNote
            // this.arrayProc
          )
            .then(dt => {
              appModule.setLoading(false);

              // console.log(dt);
              // this.overlay = !this.overlay;

              if (dt["status"] != 1) {
                appModule.sendErrorAlert(dt["message"]);
              } else {
                this.clearform();

                appModule.NoticeDelay("Berhasil Ubah Resume");

                if (this.stateuser.unit_id != "01") {
                  if (dt["data"].discharge_id == 5) {
                    if (isEmpty(this.statespri)) {
                      this.modalOpenKonfirmasi = true;
                      this.msgConfirm = "Surat Keterangan Rawat Inap";
                    }
                  } else if (dt["data"].discharge_id == 2) {
                    if (isEmpty(this.staterujukan)) {
                      this.modalOpenKonfirmasi = true;
                      this.msgConfirm = "Surat Rujukan Rawat Jalan";
                    }
                  }
                }

                this.getResume();
                storeResume.act_resume_on_reg(this.paramresume);
                this.$emit("tersimpan", {
                  discharge_id: dt["data"].discharge_id
                });
              }
            })
            .finally(() => {
              appModule.setLoading(false);
            });
        }
      }
    }
  }

  tempelDiagnosis(val) {
    if (isEmpty(this.arrayDiag)) {
      val.map(v => {
        // this.editedItemDiag.push(v);
        this.editedItemDiag.push({
          nama: v.nama,
          kode: v.kode,
          kasus: "L",
          tgl: new Date().toISOString().substr(0, 10),
          unit_id: this.stateuser.unit_id,
          dr_id: this.dokter["id"]
        });
        this.arrayDiag = this.editedItemDiag.map(item => {
          return { kode: item.kode, kasus: "L" };
        });
      });
      storeCopy.clear_copy_diagnosa();
    } else {
      appModule.sendErrorAlert(
        "Sudah ada Diagnosa tersedia, tidak bisa menimpa."
      );
    }
  }

  truncate(input) {
    if (input.length > 40) {
      return input.substring(0, 40) + "...";
    }
    return input;
  }

  @Watch("hasilDiagnosis")
  changeDiagnosis() {
    console.log("change hasil diagnosis", this.hasilDiagnosis.diagnosis);
    if (
      this.diagnosa.length == 0 &&
      this.hasilDiagnosis &&
      this.hasilDiagnosis.register_id
    ) {
      this.editedItemDiag = this.hasilDiagnosis.diagnosis;
    }
  }

  @Watch("hasilProcedure")
  changeProcedure() {
    if (
      this.tindakan.length == 0 &&
      this.hasilProcedure &&
      this.hasilProcedure.register_id
    ) {
      this.editedItemProc = this.hasilProcedure.procedure;
    }
  }

  isDiagDisabled(diag) {
    if (
      this.stateuser.id == this.dataResume[0]?.dpjp?.id ||
      this.stateuser.id == diag.dr_id
    ) {
      return false;
    } else {
      return true;
    }
  }
}
